import '../../Dropdown.css';var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
import { jsx, jsxs } from "react/jsx-runtime";
import ___default from "lodash";
import "../../Utilities.js";
import "../../Styling.js";
import { Dropdown as Dropdown$2 } from "@fluentui/react/lib/Dropdown";
import { ReadOnlyField } from "../ReadOnly/ReadOnlyField.js";
import "../Label/index.js";
import "../ValidationError/index.js";
import { getTheme } from "@fluentui/style-utilities";
import { getId, css } from "@fluentui/utilities";
import { Label } from "../Label/Label.js";
import { ValidationError } from "../ValidationError/ValidationError.js";
const Dropdown$1 = "";
const defaultClassName = "ane-Dropdown";
const defaultRootContainerClassName = "ane-Dropdown-container";
const dropdownStyles = {
  root: defaultRootContainerClassName,
  // a11y: override truncation styles to support wrapping
  dropdownOptionText: ["ane-Dropdown-option", { overflow: "visible", whiteSpace: "normal" }],
  dropdownItem: { height: "auto" },
  dropdownItemSelected: { height: "auto" }
};
const errorStyles = {
  title: ["ms-Dropdown-title--hasError", { borderColor: getTheme().semanticColors.errorText }]
};
const isRequiredLabelStyles = {
  dropdown: {
    selectors: {
      ":before": {
        content: ""
      }
    }
  }
};
const Dropdown = (props) => {
  const _a = props, {
    className,
    styles,
    id = getId("Dropdown"),
    required = false,
    disabled = false,
    label = "",
    labelProps,
    multiSelect,
    selectedKey,
    selectedKeys,
    isReadOnly,
    errorMessage
  } = _a, rest = __objRest(_a, [
    "className",
    "styles",
    "id",
    "required",
    "disabled",
    "label",
    "labelProps",
    "multiSelect",
    "selectedKey",
    "selectedKeys",
    "isReadOnly",
    "errorMessage"
  ]);
  const labelId = `${id}-label`;
  const errorMessageId = id + "-errorMessage";
  const hasErrorMessage = !___default.isEmpty(errorMessage);
  const hasErrorStyles = hasErrorMessage ? errorStyles : {};
  const requiredLabelStyles = !!label && required ? isRequiredLabelStyles : {};
  const ariaLabelledBy = !!label ? { "aria-labelledby": labelId } : {};
  let combinedStyles = __spreadValues(__spreadValues(__spreadValues(__spreadValues({}, dropdownStyles), styles), hasErrorStyles), requiredLabelStyles);
  const values = props.options.filter((option) => {
    var _a2;
    return (_a2 = multiSelect ? selectedKeys : [selectedKey]) == null ? void 0 : _a2.includes(option.key);
  });
  return isReadOnly ? /* @__PURE__ */ jsx(ReadOnlyField, { id, label, value: values.map((value) => value.text) }) : /* @__PURE__ */ jsxs("div", { id, children: [
    !!label && /* @__PURE__ */ jsx(Label, __spreadProps(__spreadValues({}, labelProps), { htmlFor: `${id}-component`, id: labelId, required, disabled, children: label })),
    /* @__PURE__ */ jsx(
      Dropdown$2,
      __spreadProps(__spreadValues(__spreadValues({}, rest), ariaLabelledBy), {
        className: css(defaultClassName, className),
        id: `${id}-component`,
        styles: combinedStyles,
        required,
        disabled,
        multiSelect,
        selectedKeys,
        selectedKey
      })
    ),
    hasErrorMessage && /* @__PURE__ */ jsx(ValidationError, { id: errorMessageId, children: errorMessage })
  ] });
};
export {
  Dropdown,
  Dropdown as default
};
//# sourceMappingURL=Dropdown.js.map
